<template>
  <v-row class="py-2">
    <v-col
      v-for="(item, index) in statsData"
      :key="index"
      cols="12"
      md="3"
      class="pt-0"
    >
      <v-card elevation="3">
        <v-row align="center" justify="center" class="px-4">
          <v-col cols="12">
            <div class="grey--text mb-2 caption">{{ item.title }}:</div>
            <div class="align-right text-right">
              <span v-if="item.increase_in_value">
                <v-icon class="green--text" v-text="$getIcon('mdiMenuUp')">
                </v-icon>
              </span>
              <span v-else>
                <v-icon class="red--text" v-text="$getIcon('mdiMenuDown')">
                </v-icon>
              </span>
              <span
                class="blue-grey--text text--darken-2 font-weight-bold pointer"
              >
                {{ item.value.toFixed(2) }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data() {
    return {
      statsData: []
    };
  },
  created() {
    this.getStatsData();
  },
  methods: {
    getStatsData() {
      const endpoint = `/api/v1/crm/report/${this.$store.state.shell.currentOrganizationId}/sub-stage-log-stats/`;
      this.$axios.$get(endpoint).then(response => {
        this.statsData = [
          {
            title: "Opportunity",
            value: response.total_opportunity || 0,
            increase_in_value: response.is_total_opportunity_increased
          },
          {
            title: "Sales Lead",
            value: response.total_lead || 0,
            increase_in_value: response.is_total_lead_increased
          },
          {
            title: "Deals",
            value: response.total_deal || 0,
            increase_in_value: response.is_total_deal_increased
          },
          {
            title: "Closed Deals",
            value: response.total_closed_deal || 0,
            increase_in_value: response.is_total_closed_deal_increased
          }
        ];
      });
    }
  }
};
</script>
